import React from 'react';
import { Content } from './Content';
import { Header } from '../Header';
import { DataExtractionReportProvider, useDataExtractionReport } from '@/context/DataExtractionReport';
import { ConfirmationModal } from '@/components/Settings/DataExtraction/Modals/ConfirmationModal';

function HierarchyContent() {
	const { showConfirmationModal, onSetShowConfirmationModal } = useDataExtractionReport();

	function handleCloseModal(): void {
		onSetShowConfirmationModal(false);
	}

	return (
		<>
			<Header />
			<Content />

			<ConfirmationModal visible={showConfirmationModal} onCancel={handleCloseModal} />
		</>
	);
}

export function Hierarchy() {
	return (
		<DataExtractionReportProvider>
			<HierarchyContent />
		</DataExtractionReportProvider>
	);
}
